// extracted by mini-css-extract-plugin
export default {"actions":"message_actions__Pu1hI","container":"message_container__N2LE7","title":"message_title__PaX6c"};